import merge from 'lodash/merge';

/**
 * @param {Object} parameters
 * @return {Object}
 */
export const defaultModalParameters = (parameters = {}) => {
    const defaultParameters = {
        adaptive:   true,
        scrollable: true,
        height:     'auto',
        maxWidth:   500
    };
    if (Object.keys(parameters).length) {
        return merge({}, defaultParameters, parameters);
    }

    return defaultParameters;
};

/**
 * @return {Object}
 */
export const imagePickerModalParameters = () => {
    return defaultModalParameters({
        maxWidth: 900,
        width:    900,
    });
};
